import { render, staticRenderFns } from "./StaffLogin.vue?vue&type=template&id=126dadf8&"
import script from "./StaffLogin.vue?vue&type=script&lang=js&"
export * from "./StaffLogin.vue?vue&type=script&lang=js&"
import style0 from "./StaffLogin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports